// Library Methods
import i18next from "i18next";

// Components
import Box from "@mui/material/Box";
import OperatingManualContent from "../OperatingManualContent/OperatingManualContent";

import colorVision1Img from "src/assets/images/operating-manual/appendix-c/color-vision-1.png";
import colorVision1FrImg from "src/assets/images/operating-manual/appendix-c/color-vision-1-fr.png";
import colorVision2Img from "src/assets/images/operating-manual/appendix-c/color-vision-2.png";
import colorVision2FrImg from "src/assets/images/operating-manual/appendix-c/color-vision-2-fr.png";
import colorVision3Img from "src/assets/images/operating-manual/appendix-c/color-vision-3.png";
import colorVision3FrImg from "src/assets/images/operating-manual/appendix-c/color-vision-3-fr.png";

// Config
import { priorityLanguageMap } from "src/config/languages";

type AppendixCType = {
  title: string;
};

const AppendixC = ({ title }: AppendixCType) => {
  const currentLang = i18next.language as keyof typeof priorityLanguageMap;

  return (
    <OperatingManualContent title={title}>
      <Box sx={{ display: "flex", flexDirection: "column", gap: "20px" }}>
        <img
          src={currentLang === "fr" ? colorVision1FrImg : colorVision1Img}
          width="100%"
          alt="cv-1"
        />
        <img
          src={currentLang === "fr" ? colorVision2FrImg : colorVision2Img}
          width="100%"
          alt="cv-2"
        />
        <img
          src={currentLang === "fr" ? colorVision3FrImg : colorVision3Img}
          width="100%"
          alt="cv-3"
        />
      </Box>
    </OperatingManualContent>
  );
};

export default AppendixC;
